export default function ServicesSection() {
  const services = [
    {
      title: 'iOS Platform Development',
      description:
        'End-to-end software engineering for the iOS ecosystem, emphasizing clean architecture patterns and maintainable codebases that scale with evolving requirements.',
      size: 'large',
      bgColor: 'bg-secondary-200/60',
    },
    {
      title: 'Performance & Optimization',
      description:
        'Systematic approach to profiling, benchmarking, and optimizing software systems for responsiveness, energy efficiency, and smooth user interactions.',
      size: 'small',
      bgColor: 'bg-accent-100/70',
    },
    {
      title: 'Technical Quality Assurance',
      description:
        'Comprehensive testing strategies, code review workflows, and continuous integration practices that ensure reliability and long-term stability.',
      size: 'small',
      bgColor: 'bg-primary-100/70',
    },
  ];

  return (
    <section className="relative py-28 md:py-36 px-4 md:px-8 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="mb-16 md:mb-20 text-center">
          <h2 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold leading-[1.15] tracking-tight text-foreground-950">
            What We
            <br />
            <span className="text-accent-500">Build</span> &amp;{' '}
            <span className="text-secondary-500">Deliver</span>
          </h2>
        </div>

        <div className="flex flex-col lg:flex-row gap-6">
          <div className="lg:w-1/2">
            <div className="relative h-[420px] md:h-[480px] rounded-2xl overflow-hidden bg-secondary-200/60">
              <div
                className="absolute inset-0"
                style={{
                  backgroundImage:
                    'linear-gradient(160deg, oklch(0.84 0.015 118 / 0.3) 0%, oklch(0.75 0.020 116 / 0.2) 40%, oklch(0.80 0.018 117 / 0.25) 100%)',
                }}
              />
              <div
                className="absolute inset-0 opacity-20"
                style={{
                  backgroundImage:
                    'repeating-linear-gradient(0deg, transparent, transparent 2px, oklch(0.5 0.01 115 / 0.1) 2px, oklch(0.5 0.01 115 / 0.1) 2.5px)',
                }}
              />
              <div className="absolute bottom-0 left-0 right-0 p-8 bg-gradient-to-t from-background-950/70 via-background-950/30 to-transparent">
                <h3 className="font-heading text-xl font-semibold text-background-50 mb-2">
                  {services[0].title}
                </h3>
                <p className="text-sm text-background-200/90 leading-relaxed max-w-md">
                  {services[0].description}
                </p>
              </div>
            </div>
          </div>

          <div className="lg:w-1/2 flex flex-col gap-6">
            {services.slice(1).map((service) => (
              <div
                key={service.title}
                className="relative h-[200px] md:h-[228px] rounded-2xl overflow-hidden"
              >
                <div className={`absolute inset-0 ${service.bgColor}`} />
                <div
                  className="absolute inset-0 opacity-15"
                  style={{
                    backgroundImage:
                      'repeating-linear-gradient(45deg, transparent, transparent 1px, oklch(0.3 0.01 80 / 0.2) 1px, oklch(0.3 0.01 80 / 0.2) 2px)',
                  }}
                />
                <div className="absolute bottom-0 left-0 right-0 p-8">
                  <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2">
                    {service.title}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed max-w-sm">
                    {service.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}